<template>
  <v-form
    ref="form"
    :class="$style.host"
    @submit.prevent="submit"
  >
    <div :class="$style.headline">Create an account</div>
    <div
      v-if="hasDistributor"
      :class="$style.title"
    >
      Your email has been verified. Please enter these fields to complete the registration process.
    </div>
    <div
      v-else
      :class="$style.title"
    >
      Please enter these fields to proceed.
    </div>
    <hr :class="$style.dividerTop">
    <div :class="$style.content">
      <div :class="$style.userForm">
        <div
          v-if="!hasDistributor"
          :class="$style.title"
        >
          <span>Your Information</span>
        </div>
        <template v-else>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <div :class="$style.label">
                <span>Company *</span>
              </div>
              <v-text-field
                :value="formDistributor.company"
                dense
                outlined
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <div :class="$style.label">
                <span>Email *</span>
              </div>
              <v-text-field
                :value="formUser.email"
                dense
                outlined
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            class="py-0"
          >
            <div :class="$style.label">
              <span>First Name *</span>
            </div>
            <v-text-field
              ref="firstName"
              v-model="formUser.firstName"
              dense
              outlined
              :rules="[
                $rules.required($v.formUser.firstName),
                $rules.maxLength($v.formUser.firstName)
              ]"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Last Name *</span>
            </div>
            <v-text-field
              ref="lastName"
              v-model="formUser.lastName"
              dense
              outlined
              :rules="[
                $rules.required($v.formUser.lastName),
                $rules.maxLength($v.formUser.lastName)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Username *</span>
            </div>
            <v-text-field
              ref="username"
              v-model="formUser.username"
              dense
              outlined
              :rules="[
                $rules.required($v.formUser.username),
                $rules.maxLength($v.formUser.username)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="!hasDistributor">
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Email *</span>
            </div>
            <v-text-field
              ref="email"
              v-model="formUser.email"
              dense
              outlined
              :rules="[
                $rules.required($v.formUser.email),
                $rules.email($v.formUser.email),
                $rules.maxLength($v.formUser.email)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Password *</span>
            </div>
            <v-text-field
              ref="password"
              v-model="formUser.password"
              dense
              outlined
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              :rules="[
                $rules.required($v.formUser.password),
              ]"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Main Industry Focus</span>
            </div>
            <v-text-field
              ref="industry"
              v-model="formUser.industry"
              dense
              outlined
              :rules="[
                $rules.maxLength($v.formUser.industry),
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Phone Number *</span>
            </div>
            <v-text-field
              ref="phone"
              v-model="formUser.phone"
              dense
              outlined
              :rules="[
                $rules.required($v.formUser.phone),
                $rules.maxLength($v.formUser.phone)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Address 1 *</span>
            </div>
            <v-text-field
              ref="address"
              v-model="formUser.address"
              dense
              outlined
              :rules="[
                $rules.required($v.formUser.address),
                $rules.maxLength($v.formUser.address)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Address 2</span>
            </div>
            <v-text-field
              ref="addressExtra"
              v-model="formUser.addressExtra"
              dense
              outlined
              :rules="[
                $rules.maxLength($v.formUser.addressExtra)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            class="py-0"
          >
            <div :class="$style.label">
              <span>City *</span>
            </div>
            <v-text-field
              ref="city"
              v-model="formUser.city"
              dense
              outlined
              :rules="[
                $rules.required($v.formUser.city),
                $rules.maxLength($v.formUser.city)
              ]"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="py-0"
          >
            <div :class="$style.label">
              <span>State *</span>
            </div>
            <div id="form-regions-select" style="position: relative">
              <v-select
                  attach="#form-regions-select"
                  ref="state"
                  v-model="formUser.state"
                  :items="regions"
                  placeholder="Select One"
                  item-text="name"
                  item-value="code"
                  dense
                  outlined
                  :rules="[
                $rules.required($v.formUser.state),
                $rules.maxLength($v.formUser.state)
              ]"
              ></v-select>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="py-0"
          >
            <div :class="$style.label">
              <span>ZIP *</span>
            </div>
            <v-text-field
              ref="zip"
              v-model="formUser.zip"
              dense
              outlined
              :rules="[
                $rules.required($v.formUser.zip),
                $rules.maxLength($v.formUser.zip)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              class="py-0"
          >
            <div :class="$style.label">
              <span>Preferred Distribution partner *</span>
            </div>
            <v-text-field
                ref="preferredPartner"
                v-model="formUser.preferredPartner"
                dense
                outlined
                :rules="[
                $rules.required($v.formUser.preferredPartner),
                $rules.maxLength($v.formUser.preferredPartner)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              class="py-0"
          >
            <div :class="$style.label">
              <span>Sales rep at Distribution partner *</span>
            </div>
            <v-text-field
                ref="salesRepPartner"
                v-model="formUser.salesRepPartner"
                dense
                outlined
                :rules="[
                $rules.required($v.formUser.salesRepPartner),
                $rules.maxLength($v.formUser.salesRepPartner),
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              class="py-0"
          >
            <div :class="$style.label">
              <span>Sales rep email address *</span>
            </div>
            <v-text-field
                ref="salesRepEmail"
                v-model="formUser.salesRepEmail"
                dense
                outlined
                :rules="[
                $rules.required($v.formUser.salesRepEmail),
                $rules.email($v.formUser.salesRepEmail),
                $rules.maxLength($v.formUser.salesRepEmail)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              class="py-0"
          >
            <div :class="$style.label">
              <span>Secondary Distribution partner</span>
            </div>
            <v-text-field
                ref="secondaryPartner"
                v-model="formUser.secondaryPartner"
                dense
                outlined
                :rules="[
                $rules.maxLength($v.formUser.secondaryPartner)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              class="py-0"
          >
            <div :class="$style.label">
              <span>Sales rep at Secondary Distribution partner</span>
            </div>
            <v-text-field
                ref="secondarySalesRepPartner"
                v-model="formUser.secondarySalesRepPartner"
                dense
                outlined
                :rules="[
                $rules.maxLength($v.formUser.secondarySalesRepPartner)
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              class="py-0"
          >
            <div :class="$style.label">
              <span>Secondary Sales rep email address</span>
            </div>
            <v-text-field
                ref="secondarySalesRepEmail"
                v-model="formUser.secondarySalesRepEmail"
                dense
                outlined
                :rules="[
                  $rules.email($v.formUser.secondarySalesRepEmail),
                  $rules.maxLength($v.formUser.secondarySalesRepEmail)
                ]"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div
        v-if="!hasDistributor"
        :class="$style.distributorForm"
      >
        <div :class="$style.title">
          <span>Company Information</span>
        </div>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Company *</span>
            </div>
            <v-text-field
              ref="company"
              v-model="formDistributor.company"
              dense
              outlined
              :rules="[
                $rules.required($v.formDistributor.company),
                $rules.maxLength($v.formDistributor.company)
              ]"
              @change="onCompanyChange"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div :class="$style.label">
              <span>Company URL *</span>
            </div>
            <v-text-field
              ref="companyURL"
              v-model="formDistributor.companyURL"
              dense
              outlined
              :rules="[
                $rules.required($v.formDistributor.companyURL),
                $rules.url($v.formDistributor.companyURL),
                $rules.maxLength($v.formDistributor.companyURL)
              ]"
              @change="onCompanyChange"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
    </div>
    <hr :class="$style.dividerBottom">
    <div :class="$style.buttons">
      <v-btn
        outlined
        :class="['unr-button-default', $style.button]"
        @click="resetState"
      >
        Cancel
      </v-btn>

      <v-btn
          color="primary"
          type="submit"
          :class="['unr-button', $style.button]">
        Submit
      </v-btn>
    </div>
    <registration-success
      v-model="showSuccessModal"
      @close="onSuccessModalClose"
    />
    <company-exist
        v-model="showCompanyExistModal"
        v-bind:distributorCompany="formDistributor.company"
        @close="onCompanyExistModalClose"
    />
    <v-overlay
      absolute
      :value="loading"
      opacity="0.3"
      color="#1976d2"
      z-index="9999"
    >
      <v-progress-circular
        indeterminate
        size="70"
        color="white"
      />
    </v-overlay>
  </v-form>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import {
  CREATE_BOTH,
  CREATE_USER,
  RESET_STATE,
  START_LOADING,
  STOP_LOADING,
  COMPANY_EXIST,
  SET_DISTRIBUTOR_COMPANY,
  SET_USER_EMAIL,
} from '@/features/registration/store/modules/registration';
import regions from '@/data/us-regions';
import { scrollToError, url } from '@/validators';
import { email, maxLength, required } from 'vuelidate/lib/validators';
import RegistrationSuccess from '@/features/registration/components/registration-success';
import CompanyExist from '@/features/registration/components/company-exist';
import { VueReCaptcha } from 'vue-recaptcha-v3';

const recaptchaSiteKey = (registrationFormVars && registrationFormVars.siteKey) ? registrationFormVars.siteKey : '';

Vue.use(VueReCaptcha, { siteKey: recaptchaSiteKey });

export default {
  name: 'Registration',
  components: {
    RegistrationSuccess,
    CompanyExist
  },
  data: () => ({
    recaptchaSiteKey,
    recaptchaToken: '',
    formUser: {
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      password: '',
      industry: '',
      phone: '',
      address: '',
      addressExtra: '',
      city: '',
      state: '',
      zip: '',
      preferredPartner: '',
      salesRepPartner: '',
      salesRepEmail: '',
      secondaryPartner: '',
      secondarySalesRepPartner: '',
      secondarySalesRepEmail: '',
    },
    formDistributor: {
      company: '',
      companyURL: '',
    },
    showPassword: false,
    showSuccessModal: false,
    showCompanyExistModal: false,
    regions,
  }),
  validations() {
    const validations = {
      formUser: {
        firstName: { required, maxLength: maxLength(50) },
        lastName: { required, maxLength: maxLength(50) },
        username: { required, maxLength: maxLength(50) },
        password: { required },
        industry: { maxLength: maxLength(50) },
        phone: { required, maxLength: maxLength(15) },
        address: { required, maxLength: maxLength(50) },
        addressExtra: { maxLength: maxLength(50) },
        city: { required, maxLength: maxLength(50) },
        state: { required, maxLength: maxLength(2) },
        zip: { required, maxLength: maxLength(9) },
        preferredPartner: { required, maxLength: maxLength(50) },
        salesRepPartner: { required, maxLength: maxLength(50) },
        salesRepEmail: { required, email, maxLength: maxLength(50) },
        secondaryPartner: { maxLength: maxLength(50) },
        secondarySalesRepPartner: { maxLength: maxLength(50) },
        secondarySalesRepEmail: { email, maxLength: maxLength(50) },
      },
    };
    if (!this.hasDistributor) {
      validations.formDistributor = {
        company: { required, maxLength: maxLength(50) },
        companyURL: { required, url, maxLength: maxLength(50) },
      };
      validations.formUser.email = { required, email, maxLength: maxLength(50) };
    }
    return validations;
  },
  computed: {
    ...mapState([
      'loading',
      'userEmail'
    ]),
    ...mapGetters([
      'hasDistributor',
    ]),
  },
  methods: {
    ...mapActions({
      createUser: CREATE_USER,
      createBoth: CREATE_BOTH,
      companyExists: COMPANY_EXIST,
    }),
    ...mapMutations({
      resetState: RESET_STATE,
      startLoading: START_LOADING,
      stopLoading: STOP_LOADING,
      setDistributorCompany: SET_DISTRIBUTOR_COMPANY,
      setUserEmail: SET_USER_EMAIL,
    }),
    async submit() {
      this.$v.$touch();
      this.$refs.form.validate();

      if (this.$v.$invalid) {
        scrollToError(
          {
            ...this.$v.formUser,
            ...this.$v.formDistributor,
          },
          this.$refs,
        );

        return;
      }

      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('submit');

      if (!token) {
        console.log('token', token);
        return;
      }

      this.startLoading();
      try {
        if (this.hasDistributor) {
          await this.createUser({
            user: this.formUser,
            recaptchaToken: token
          });
        } else {
          await this.createBoth({
            user: this.formUser,
            distributor: this.formDistributor,
            recaptchaToken: token
          });
        }
        this.showSuccessModal = true;
      } catch (error) {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          closeOnClick: true,
          duration: 20000,
          text: error.message,
        });
      } finally {
        this.stopLoading();
      }
    },
    onSuccessModalClose() {
      this.resetState();
      window.location.href = '/';
    },
    async onCompanyExistModalClose(answer) {
      if (answer) {
        this.showCompanyExistModal = false;

        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        await this.setDistributorCompany('');

        this.$refs.company.valid = false;
        this.$refs.companyURL.valid = false;
        this.$refs.company.errorBucket.push('Company with that name already exist.');
        this.$refs.companyURL.errorBucket.push('Company with that URL already exist.');
      }
    },
    async onCompanyChange() {
      if (!this.formDistributor.companyURL.length
        || !this.formDistributor.company.length
        || !this.$refs.companyURL.valid) {
        return;
      }

      this.startLoading();

      try {
        const result = await this.companyExists({
          company: this.formDistributor.company,
          url: this.formDistributor.companyURL
        });

        if (this.formUser.email.length && this.$refs.email.valid) {
          this.setUserEmail(this.formUser.email);
        }

        if (result.companyName) {
          this.setDistributorCompany(result.companyName);
          this.formDistributor.company = result.companyName;
        } else {
          this.setDistributorCompany(this.formDistributor.company);
        }

        this.showCompanyExistModal = true;
      } catch (error) {
        // this.$notify({
        //   group: 'foo',
        //   type: 'success',
        //   title: 'Success',
        //   closeOnClick: true,
        //   duration: 20000,
        //   text: error.message + 'sdsds',
        // });
      } finally {
        this.stopLoading();
      }
    },
  },
  watch: {
    userEmail(value) {
      this.formUser.email = value;
    }
  },
  created() {
    if (this.hasDistributor) {
      this.formUser.email = this.$store.state.userEmail;
      this.formDistributor.company = this.$store.state.distributorCompany;
    }
  },
};
</script>

<style lang="scss" module>
.host {
  max-width: 1140px;
  margin: 0 auto 2% auto;
  padding: 0 15px;

  .dividerTop {
    color: #dddddd;
    margin-top: 30px;
    margin-bottom: 15px;
  }

  .dividerBottom {
    color: #dddddd;
    margin-top: 5px;
    margin-bottom: 30px;
  }

  .content {
    max-width: 558px;
  }

  .headline {
    @include font-rubik-grey(32px, 500, 38px);
  }

  .title {
    margin-top: 5px;

    > span {
      @include font-rubik-grey(20px, 500, 28px, uppercase);
    }
  }

  .label {
    @include font-open-sans-grey(16px, 600, 24px);
  }

  .buttons {
    max-width: 558px;
    display: flex;
    justify-content: space-between;
  }

  .button {
    width: 50%;
    flex: 1 1 auto;

    &:not(:last-child) {
      margin-right: 15px;
    }
  }

  .userForm {
    margin-top: 30px;
  }

  .distributorForm {
    margin-top: 30px;
  }
}
</style>

<style lang="scss">
#g-recaptcha {

  & > div {
    margin: 0 auto 20px;
  }
}
</style>
